import React from "react";
import { Link } from "react-router-dom";
import { Globe2, LineChart, Zap, MessageCircle, Users, ArrowRight } from "lucide-react";
import { featureCards } from "../mock";

const ICONS = {
  globe: Globe2,
  chart: LineChart,
  lightning: Zap,
  bubble: MessageCircle,
};

const FeatureCard = ({ card }) => {
  const Icon = ICONS[card.icon] || Globe2;
  return (
    <div className="bb-card bb-card-hover rounded-3xl p-8 lg:p-10 relative overflow-hidden group h-full">
      <div className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-gradient-to-br from-[#1c3df5]/30 to-transparent blur-3xl opacity-60 group-hover:opacity-100 transition-opacity duration-500"></div>
      <div className="relative z-10">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#1c3df5] to-[#0f1ea8] flex items-center justify-center mb-6 shadow-lg shadow-[#1c3df5]/30">
          <Icon size={28} className="text-white" strokeWidth={1.8} />
        </div>
        <h3 className="font-display text-[26px] lg:text-[30px] leading-tight font-bold text-white mb-3">
          {card.title}
        </h3>
        <p className="text-[15px] bb-text-mute leading-relaxed">{card.desc}</p>
      </div>
    </div>
  );
};

const FeaturesGrid = () => {
  return (
    <section className="py-20 lg:py-28 relative">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8">
        <div className="grid md:grid-cols-2 gap-5 lg:gap-6">
          {featureCards.map((c) => (
            <FeatureCard key={c.id} card={c} />
          ))}
        </div>

        {/* CTA Banner + Refer */}
        <div className="grid lg:grid-cols-2 gap-5 lg:gap-6 mt-6">
          <div className="bb-card rounded-3xl p-8 lg:p-12 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-[#1c3df5]/20 via-transparent to-transparent"></div>
            <div className="relative z-10">
              <h3 className="font-display text-[28px] lg:text-[34px] leading-tight font-bold text-white mb-3">
                Start trading today
              </h3>
              <p className="bb-text-mute text-[15px] mb-7 max-w-md leading-relaxed">
                Open a live account with Northwind and access global markets with competitive spreads and fast execution. Take the first step toward your trading success.
              </p>
              <Link
                to="/signup"
                data-testid="features-open-account-cta"
                className="inline-flex items-center gap-2 px-6 py-3 bb-blue text-white font-medium rounded-lg transition-all hover:gap-3"
              >
                Open account <ArrowRight size={18} />
              </Link>
            </div>
          </div>

          <div className="bb-card rounded-3xl p-8 lg:p-12 relative overflow-hidden">
            <div className="absolute -top-10 -right-10 w-64 h-64 rounded-full bg-gradient-to-br from-[#3b59ff]/30 to-transparent blur-3xl"></div>
            <div className="relative z-10">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#1c3df5] to-[#0f1ea8] flex items-center justify-center mb-6 shadow-lg shadow-[#1c3df5]/30">
                <Users size={28} className="text-white" strokeWidth={1.8} />
              </div>
              <h3 className="font-display text-[26px] lg:text-[30px] leading-tight font-bold text-white mb-3">
                Trade together. Gain together.
              </h3>
              <p className="bb-text-mute text-[15px] mb-6 max-w-md leading-relaxed">
                Refer your friends and earn with Northwind! Earn cash bonuses of up to $1,500.
              </p>
              <Link
                to="/signup"
                data-testid="refer-cta"
                className="inline-flex items-center gap-2 text-white font-medium hover:text-[#7d8eff] transition-colors"
              >
                Refer a friend <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;
